import React, { useEffect, useState } from "react";
import styles from "./BettingControls.module.css";
import { useSelector } from "react-redux";
import dollarCoin from "../../images/dollarCoin.webp";
import half from "../../images/half.webp";
import clickAudio from "../../audios/click.mp3";
import getSoundEffectVolume from "../../utils/getSoundEffectVolume";
import useSound from "use-sound";

const BettingControls = ({ isChangeable, onChange }) => {
  const user = useSelector((state) => state.user);
  const sounds = useSelector((state) => state.sounds);
  const gameSettings = useSelector((state) => state.gameSettings);
  const [amount, setAmount] = useState(1);
  const [playClickSound] = useSound(clickAudio, {
    volume: getSoundEffectVolume(),
    soundEnabled: !sounds.isSoundEffectsMute,
  });
  const clickSound = () => {
    playClickSound();
  };

  const changeAmount = (amount) => {
    setAmount(amount);
    onChange(amount);
    localStorage.setItem("betAmount", amount);
  };

  const handleBlur = () => {
    if (isChangeable) {
      if (amount > 1 && amount <= user.balance) {
        changeAmount(amount);
      } else {
        changeAmount(1);
      }
    }
  };
  const handleHalf = () => {
    if (isChangeable) {
      const newBalance = parseInt(amount / 2);
      clickSound();
      if (newBalance > 1 && newBalance <= user.balance) {
        changeAmount(newBalance);
      } else {
        changeAmount(1);
      }
    }
  };
  const handleDouble = () => {
    if (isChangeable) {
      const newBalance = parseInt(amount * 2);
      clickSound();
      if (newBalance > 1 && newBalance <= user.balance) {
        changeAmount(newBalance);
      } else {
        changeAmount(1);
      }
    }
  };

  useEffect(() => {
    if (amount !== null && amount !== undefined) {
      if (gameSettings.betAmount !== amount) {
        changeAmount(parseInt(gameSettings.betAmount));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameSettings]);

  return (
    <div
      className={`${styles.controlGroup} ${
        isChangeable ? "" : styles.disableToClick
      }`}
    >
      <label className={styles.inputLabel}>Bet Amount</label>
      <span className={styles.betContainer}>
        <span className={styles.betInputWrapper}>
          <input
            type="number"
            style={{ position: "relative" }}
            className={styles.inputField}
            value={amount}
            step="any"
            min={1}
            max={user.balance}
            isChangeable={isChangeable}
            onBlur={handleBlur}
            onChange={(e) => {
              if (isChangeable) {
                const val = parseInt(e.target.value);
                setAmount(val);
              }
            }}
          />
          <img
            src={dollarCoin}
            alt={dollarCoin}
            className={styles.dollarIcon}
          />
        </span>
        <img
          src={half}
          alt={"half"}
          className={`${styles.half} ${
            isChangeable ? styles.ableToClick : styles.disableToClick
          }`}
          onClick={handleHalf}
        />
        <span className={styles.gap} />
        <span
          className={`${styles.doubleButton} ${
            isChangeable ? styles.ableToClick : styles.disableToClick
          }`}
          onClick={handleDouble}
        >
          x2
        </span>
      </span>
    </div>
  );
};

export default BettingControls;
